'use client';

import React from 'react';

import { usePathname } from 'next/navigation';

import Container from '@repo/ui/container';

import ContactForm from 'components/contact-form';

import { styles } from '.';

const FormSection = () => {
  const pathname = usePathname();

  if (pathname.includes('/contact')) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Container>
        <div className={styles.content}>
          <div className="max-w-4xl pb-6">
            <h1 className="text-lg font-medium text-black">
              Doortimmerd advies
            </h1>
            <p className="text-sm text-gray-400">
              Contacteer ons voor een gratis advies of een transparante offerte.
              Als jij je (woon)dromen met ons deelt, helpen we die graag
              waarmaken.
            </p>
          </div>

          <div className="w-full max-w-4xl text-black">
            <ContactForm
              gtmId={process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID as string}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FormSection;
